import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import getAttributeLink from './get-attribute-link';

const selectAttributesChartData = (ranking, averageRanking, phrases, sortOrder, linkPath = '', percentages = false) => {
  const mappedData = map(ranking, (value, key) => ({
    ranking: (value || 0) * (percentages ? 10 : 1),
    attributeName: phrases[`${key}Title`],
    averageRanking: (averageRanking[key] || 0) * (percentages ? 10 : 1),
    sortKey: sortOrder.indexOf(key),
    key,
    link: getAttributeLink(linkPath, key),
  }));
  return sortBy(mappedData, 'sortKey');
};

export default selectAttributesChartData;
